<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- Cancel Input Popup -->
    <transition name="popup">
      <PCServiceLicenseCancelCancel
        v-if="state.visibleCancelInput"
        @closeServiceLicenseCancel="state.visibleCancelInput = false"
      />
    </transition>

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button"
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
        >
        <div class="service" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="service-head">
            <h1 class="hdg03">{{selectPackage.package_name}}</h1>
          </div>
          <form action="" method="post" class="service-container" :class="[(!isCancelPackage && !isTrialPackage) && 'service-container-notxt']">
            <div v-if="isTrialPackage" class="service-content">
              <p class="txt mb72">ライセンスの有効期限は{{formatDateKanji(selectPackage.period_end)}}までです。</p>
              <div class="tbl01 service-content-table">
                <table class="tbl">
                  <thead>
                    <tr>
                      <th class="w80">&nbsp;</th>
                        <th class="w20 ta-center">契約中のライセンス数</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(product, index) in trialProduct" :key="'basicProduct_' + index">
                      <td class="w80">{{product.name}} </td>
                      <td class="w20 ta-center">{{product.license_number}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-else class="service-content">
              <p v-if="isCancelPackage" class="txt mb72">次年の解約予約は受付済みです。<br>現在ご契約中のライセンス有効期限は{{formatDateKanji(selectPackage.period_end)}}までです。</p>
              <p v-else class="txt mb72">現在ご契約中のライセンス有効期限は{{formatDateKanji(selectPackage.period_end)}}までです。</p>
              <div class="tbl01 service-content-table">
                <table class="tbl">
                  <thead>
                    <tr>
                      <th class="w40">&nbsp;</th>
                      <th class="w20 ta-center">契約中のライセンス数</th>
                      <th class="w20 ta-center">次年のライセンス数</th>
                      <th class="w20">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(product, index) in basicProduct" :key="'basicProduct_' + index">
                      <td class="w40">{{product.name}} </td>
                      <td class="w20 ta-center">{{product.status === PRODUCT_STATUS.UNSIGNED ? '未購入' : product.license_number}}</td>
                      <template v-if="isCancelPackage">
                        <td class="w20 ta-center"><span class="txt-gray">解約予約済</span></td>
                        <td class="w20"><span class="txt-blue" @click="clickCancelReserve(product)" role="button">解約予約の取り消し</span></td>
                      </template>
                      <template v-else-if="product.cancel_license_number > 0">
                        <td class="w20 ta-center"><span class="txt-gray">{{
                          product.license_number - product.cancel_license_number === 0 ? '解約予約済': product.license_number - product.cancel_license_number
                          }}</span></td>
                        <td class="w20"><span class="txt-blue" @click="clickCancelReserve(product)" role="button">解約予約の取り消し</span></td>
                      </template>
                      <template v-else>
                        <td class="w20 ta-center">{{product.status === PRODUCT_STATUS.UNSIGNED ? '-' : product.license_number - product.cancel_license_number}}</td>
                        <td class="w20">&nbsp;</td>
                      </template>
                    </tr>
                    <!-- オプション -->
                    <tr v-for="(product, index) in optionProduct" :key="'optionProduct_' + index">
                      <td class="w40 pl40">{{product.name}} </td>
                      <td class="w20 ta-center">{{product.status === PRODUCT_STATUS.UNSIGNED ? '未購入' : product.license_number}}</td>
                      <template v-if="isCancelPackage">
                        <td class="w20 ta-center"><span class="txt-gray">解約予約済</span></td>
                        <td class="w20">&nbsp;</td>
                      </template>
                      <template v-else-if="(PRODUCT_STATUS.CANCEL_PRODUCT.includes(product.status) || product.cancel_license_number > 0) && !isTrialPackage">
                        <td class="w20 ta-center"><span class="txt-gray">{{
                          product.license_number - product.cancel_license_number === 0 ? '解約予約済': product.license_number - product.cancel_license_number
                          }}</span></td>
                        <td class="w20"><span class="txt-blue" @click="clickCancelReserve(product)" role="button">解約予約の取り消し</span></td>
                      </template>
                      <template v-else>
                        <td class="w20 ta-center">{{product.status === PRODUCT_STATUS.UNSIGNED ? '-' : product.license_number - product.cancel_license_number}}</td>
                        <td class="w20">&nbsp;</td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="!isOldPackage && isAgreement && !isCancelPackage" class="service-btn">
                <div class="button" :class="(state.isUnderExam || state.boughtThisMonthDifPayment) ? 'is-inactive' : ''">
                  <a v-if="state.isUnderExam || state.boughtThisMonthDifPayment" href="javascript:void(0)" class="btn">ライセンスの購入</a>
                  <router-link v-else to="/pc/service-license-purchase-input" class="btn">ライセンスの購入</router-link>
                </div>
            </div>
            <div v-if="state.isUnderExam" class="service-content mt20">
              <p class="txt">お支払い方法の審査を行っております。審査終了まで追加購入、ライセンス追加購入は行えませんのでご了承ください。</p>
            </div>
            <div v-else-if="state.boughtThisMonthDifPayment">
              <p class="txt">既定のお支払い方法を変更した場合は当月の追加購入は行えません。翌月より追加購入を行えますのでご了承ください。</p>
            </div>

            <div v-if="!isOldPackage && !isAgreement" class="service-btn">
                <div class="button">
                  <router-link to="/pc/estimate-input" class="btn">お見積り</router-link>
                </div>
            </div>
            <div v-if="!isCancelPackage && !isTrialPackage && isAgreement" class="service-link">
              <router-link to="/pc/service-license-cancel-input" class="link">ライセンスの解約（次年）</router-link>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import store from '@/store'
import { ServiceDetail } from '@/logic/contract/ServiceDetail.js'

import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCServiceLicenseCancelCancel from '@/components/pc/popup/PCServiceLicenseCancelCancel.vue'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu,
    PCServiceLicenseCancelCancel
  },
  beforeRouteEnter(to, from, next) {
    const { contractPack: {selectPackage} } = store.state
    if (selectPackage) {
      next()
    } else {
      next({path: '/pc/service'})
    }
  },
  setup (props, context) {
    return { ...ServiceDetail(context) }
  }
})
</script>

<style lang="scss" scoped>
#header {
  @media screen and (max-width: 1250px) {
    .header-search-tab {
      position: relative;
      &-02 {
        position: absolute;
        top: 52px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
        .header-search-tab-item {
          height: 48px;
          padding: 0 10px;
          a {
            color: $color-link;
            padding: 2px 10px;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.service {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0 150px;
    &-notxt {
      padding: 72px 0 150px;
    }
  }
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    .hdg03{
      margin: 48px 0 15px;
    }
    .txt {
      line-height: 1.625;
    }
    .txt-gray{
      color: #999;
    }
    &-table{
      thead{
        th{
          background: $color-bg-paper;
          border-bottom: 0;
          font-weight: normal;
          padding: 24px 20px;
        }
      }
      tbody{
        td{
          padding: 24px 20px;
          span.txt-blue + span.txt-blue{
            margin-left: 35px;
            padding-left: 20px;
            border-left: 1px solid rgba(153, 153, 153, 0.2);
          }
        }
      }
    }
  }
  &-btn{
    width: 230px;
    margin: 31px auto 0;
  }
  &-link{
    display: block;
    text-align: center;
    margin-top: 30px;
    a {
      color: $color-link;
    }
  }
}
</style>
